export default __webpack_public_path__ + "images/angle-down_30d304503eeb7afa404bc98c679fa9cc.svg";